import { ICall } from 'features/calls/types'

export interface IEntity {
  entityId: string
  slot?: string
  typeId?: string
  description?: string
}

export interface IEntityVersion {
  entityVersionId?: string
  entityBagId?: string
  entity?: IEntity
  establishedId?: string
  evIdPrevious?: string
  entityId?: string
  established?: IEntityBag
  entityValue: string | null
}

export interface IGetEntityResponse {
  count: number
  limit: number
  offset: number
  data: IEntity[]
}

export interface IActivity {
  activityId?: string
  description: string
}

export interface IActor {
  actorId?: string
  description: string
}

export interface IEntityBag {
  entityVersions?: IEntityVersion[]
  entities?: any
  claimActivityId?: string
  entityBagId?: string
  oaiClaimId?: string
  predecessorId?: string
  actorId: string
  actorName: string
  activityId: string
  callJobId?: string
  remarks: string
  created?: string
  actor?: IActor
  activity?: IActivity
  callJob?: ICall
}

export interface IClaimActivities {
  entityVersions?: IEntityVersion[]
  claimActivityId: string
  entityBagId?: string
  oaiClaimId?: string
  predecessorId?: string
  actorId: string
  actorName: string
  userName?: string
  activityId: string
  callJobId?: string
  remarks: string
  created?: string
  callJob?: ICall
}

export class EntityDictionary {
  map: Map<string, IEntity>
  constructor(entities: IEntity[]) {
    this.map = new Map()
    entities?.forEach((entity) => this.map.set(entity.entityId, entity))
  }

  GetEntity(entityId: string): IEntity | undefined {
    return this.map.get(entityId)
  }
}

export const getEntityVersionFromClaim = (entityId: string, entityBag?: IEntityBag): IEntityVersion | undefined => {
  return entityBag?.entityVersions?.find((ev) => ev.entityId === entityId)
}

export const getEntityVersionFromBag = (entityId: string, entityBag?: IEntityBag): IEntityVersion | undefined => {
  return entityBag?.entityVersions?.find((ev) => ev.entityId === entityId && ev.establishedId === entityBag.entityBagId)
}
